"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("topbarAppSwitcher", function ($location, $translate, $applications, $authz, $session) {
  var IGNORED_APPS = ["INTRA", "OBSERVATOIRE"];
  return {
    restrict: 'E',
    replace: true,
    template: require('./topbar-app-switcher.html'),
    link: function link($scope, $el, $attrs) {
      var currentAppId = $applications.getCurrentAppId();
      var appLabelKey = "topbar.appLabel." + currentAppId;
      if (currentAppId === 'OBSERVATOIRE_FINANCIER' && $authz.hasRole('OBSERVATOIRE_FINANCIER_SIMPLIFIE')) {
        appLabelKey += ".COMPAROSCOPE";
      }
      ;
      if (currentAppId === 'AIDE_SUBVENTION' && $authz.hasRole('SUBVENTION_COLLABORATEUR_EXTERNE')) {
        appLabelKey += ".PORTAIL";
      }
      ;
      $scope.appLabel = $translate(appLabelKey);
      $scope.applications = _.reject($applications.getAllowedApplications(), function (app) {
        return app.id === currentAppId || _.includes(IGNORED_APPS, app.id);
      });
      $scope.externalApplications = $session.getExternalApplications();
      $scope.showSwitcher = ($scope.applications.length > 0 || $scope.externalApplications.length > 0) && !_.includes(IGNORED_APPS, currentAppId);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/topbar/app-switcher/topbar-app-switcher.js
// module id = 3021
// module chunks = 13